module.exports = __webpack_public_path__ + "img/040.225fc431.jpg";